import styled, { css } from 'styled-components'
import { containerNarrow } from '../../lib/styles/Container'

export const TeaserCardCollageWrapper = styled.div`
  margin-block: 6rem;
`

export const TeaserCardCollageContainer = styled.div`
  margin-inline: auto;
  ${containerNarrow}
`

export const TeaserCardCollageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 3rem;
  text-align: center;
`

export const TeaserCardCollageSlider = styled.div`
  overflow: hidden;

  @media screen and (min-width: 860px) {
    display: none;
  }

  .swiper {
    overflow: visible;
    margin-inline: -0.5rem;
  }

  .swiper-slide {
    height: auto;
    padding: 0.5rem;
  }
`

export const TeaserCardCollageSliderInner = styled.div`
  ${containerNarrow};
  margin-inline: auto;
`

export const TeaserCardCollageGridItem = styled.div``

export const TeaserCardCollageGrid = styled.div<{ alternativeLayout?: boolean }>`
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(10, 1fr);

  @media screen and (max-width: 859px) {
    display: none;
  }

  ${TeaserCardCollageGridItem} {
    grid-column: span 4;

    &:nth-child(4n + 1),
    &:nth-child(4n + 4) {
      grid-column: span 6;
    }

    ${p =>
    p.alternativeLayout &&
    css`
        &:last-child {
          grid-column: 3 / span 6;
        }
      `}
  }
`
